import Cohere from 'cohere-js';
Cohere.init('-n0bkUfN1mcEdcTN5TtZDnm3');
